import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getVmsUserRole, isVmsAuthenticated } from "../utils/auth";

const VmsRoleRoute = ({ allowedRoles = [] }) => {
  if (!isVmsAuthenticated()) {
    return <Navigate to="/vms/login" replace />;
  }

  const role = getVmsUserRole();
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/vms/requests" replace />;
  }

  return <Outlet />;
};

export default VmsRoleRoute;
